export default {
    common: {
        title: "Muokkaa kuvaa",
        cancel: "Peruuttaa",
        save: "Tallenna",
        crop: "Sato",
        adjustments: "Säädökset",
        filters: "Suodattimet",
        frames: "Kehykset",
        overlays: "Kerroksia",
        text: "Teksti",
        stickers: "Tarroja",
        brush: "Harja",
        ai: "Luo kuva käyttäen tekoälyä",
        reset: "Nollaa",
        comingSoon: 'Tulossa pian...',
    },
};
